import { Link, useLocation } from 'react-router-dom';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function NotFound() {
  const location = useLocation();
  usePageMeta('页面未找到 - 漂亮的姐姐');

  return (
    <div className="w-full max-w-page mx-auto px-4 md:px-6 py-20 flex flex-col items-center text-center">
      <span className="w-20 h-20 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center mb-6">
        <i className="ri-film-line text-4xl"></i>
      </span>
      <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">页面走丢了</h1>
      <p className="mt-3 text-sm md:text-base text-foreground-600">
        抱歉，你访问的页面不存在或已被移除。
      </p>
      <p className="mt-1 text-xs text-foreground-400 break-all">{location.pathname}</p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="px-5 py-2.5 rounded-md bg-accent-500 text-background-50 dark:text-foreground-950 text-sm font-label font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          返回首页
        </Link>
        <Link
          to="/category/tv-series"
          className="px-5 py-2.5 rounded-md border border-background-300 text-foreground-800 text-sm font-label hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          浏览电视剧
        </Link>
        <Link
          to="/search"
          className="px-5 py-2.5 rounded-md border border-background-300 text-foreground-800 text-sm font-label hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          去搜索内容
        </Link>
      </div>
    </div>
  );
}